/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

console.log("application.js is running!");
//import "..assets/stylesheets/application.scss";
import "../stylesheets/application.scss";

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
// Import Bootstrap JS bundle
import { Toast } from "bootstrap";
window.bootstrap = { Toast };
//require("video.js/dist/video-js.css");
const application = Application.start();
const context = require.context("controllers", true, /\.js$/);
application.load(definitionsFromContext(context));
require("@rails/activestorage").start();

function initializeHeaderDropdowns() {
  const $ = window.jQuery || window.$;
  if (!$ || !$.fn.dropdown) return;

  $('[data-toggle="dropdown"]').dropdown();
}

document.addEventListener("turbolinks:load", initializeHeaderDropdowns);

// Initialize Bootstrap tooltips
document.addEventListener("DOMContentLoaded", function () {
  if (!window.bootstrap?.Tooltip) return;

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new window.bootstrap.Tooltip(tooltipTriggerEl, {
      trigger: "hover",
    });
  });
});
